<template>
  <DialogHybrid
    v-model="open"
    :sheet-title="t(title)"
    :dialog-props="{ maxWidth: 460 }"
  >
    <v-container class="text-center pa-4 pa-md-6">
      <h3 class="d-none d-md-block text-h6 mb-2 font-weight-semibold" v-text="t(title)" />
      <p class="text-body-1 mb-4" v-text="t(message)" />

      <div class="d-flex flex-column ga-3">
        <BrandButton
          v-for="(button, i) in buttons"
          :key="i"
          v-bind="button.props"
          @click="button.action"
        >
          {{ t(button.text) }}
        </BrandButton>
      </div>
    </v-container>
  </DialogHybrid>
</template>

<script setup>
import { ref, computed, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import DialogHybrid from '@/components/global/DialogHybrid.vue'
import BrandButton from '@/components/global/brand/BrandButton.vue'
import { useRatingDialog } from '@/composables/useRatingPrompt'

const { t } = useI18n()
const { dialogOpen, settleRatingDialog } = useRatingDialog()

// 'ask' -> soft-ask; 'feedback' -> shown after a negative answer.
const step = ref('ask')

// Reset to the first step whenever the dialog (re)opens.
watch(dialogOpen, isOpen => { if (isOpen) step.value = 'ask' })

// Two-way binding to the shared open flag. Setting false (tap-outside / back /
// swipe-down) counts as a dismissal -> null result.
const open = computed({
  get: () => dialogOpen.value,
  set: val => { if (!val) settleRatingDialog(null) },
})

const title = computed(() => (step.value === 'ask' ? 'rating.softask.title' : 'rating.feedback.title'))
const message = computed(() => (step.value === 'ask' ? 'rating.softask.message' : 'rating.feedback.message'))

const defaultProps = { size: 'x-large', block: true }

// Positive / primary action first.
const buttons = computed(() => {
  if (step.value === 'ask') {
    return [
      { props: { ...defaultProps, variant: 'primary' }, text: 'rating.softask.yes', action: () => settleRatingDialog('positive') },
      { props: { ...defaultProps, variant: 'basic' }, text: 'rating.softask.no', action: () => { step.value = 'feedback' } },
    ]
  }
  return [
    { props: { ...defaultProps, variant: 'primary' }, text: 'rating.feedback.yes', action: () => settleRatingDialog('feedback') },
    { props: { ...defaultProps, variant: 'basic' }, text: 'rating.feedback.no', action: () => settleRatingDialog('negative') },
  ]
})
</script>
